import Layout from '../../../components/Layout';
import { PositionTable } from './Table';

export default function Position() {
  return (
    <Layout>
      <PositionTable />
    </Layout>
  );
}
